import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

interface ContainerProps {
  fullWidth?: boolean
  disabled?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  container: (props: ContainerProps) => ({
    '&&': {
      display: 'flex',
      alignItems: 'center',

      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.s}`,
      backgroundColor: props.disabled
        ? theme.palette.custom.greyTransparent
        : theme.palette.custom.white,

      border: `1px solid ${theme.palette.custom.grey}`,
      width: 390,

      [theme.breakpoints.down('tablet')]: {
        borderRadius: 10,
        width: '100%',
      },

      [theme.breakpoints.up('tablet')]: {
        height: 80,

        borderRadius: 15,
      },

      transition: 'background-color 0.3s ease-in-out',
    },
  }),

  phoneInput: {
    '&&': {
      // borderRadius: '.5rem',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
      fontSize: '1.25rem',
    },
  },

  phoneInputWrapper: {
    '&&': {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      gap: '8px',
      height: '28px',
    },
  },

  codeInput: {
    '&&': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      gap: '8px',
      borderRadius: '8px',
      height: '28px',
      width: 'auto',
    },
  },

  options: {
    position: 'absolute',
    top: '4rem',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: '.5rem',
    zIndex: 30,
  },

  searchBox: {
    backgroundColor: 'var(--primary)',
    color: '#fff',
    borderRadius: '.5rem .5rem 0 0',
    padding: '1.4rem 1rem',
  },

  error: {
    color: 'red',
    marginTop: '0.5rem',
  },
}))

export default useStyles
